import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import logo from "../assets/images/helloSuperStar.png";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import "../assets/CSS/Navbar.css";
import TopInfo from "./TopInfo";

const AdminNavbar = () => {
  const history = useHistory();
  const [scheduleNofication, setscheduleNofication] = useState([]);
  const sidebarToggle = () => {
    document.body.classList.toggle("sb-sidenav-toggled");
    localStorage.setItem(
      "sb|sidebar-toggle",
      document.body.classList.contains("sb-sidenav-toggled")
    );
  };

  useEffect(() => {
    axios.get(`/api/admin/schedule/notification`).then((res) => {
      if (res.status === 200) {
        setscheduleNofication(res.data.schedules);
      }
    });
  }, []);

  return (
    <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
      <div className="d-flex justify-content-between align-items-center desk-tab-x ">
        <div>
          <Link className="Link" to="/superstar-admin">
            <img
              src={logo}
              alt=""
              className="logo-ad-logo mx-2"
              style={{ width: "40px" }}
            />
            <span className="navbar-brand LogoName">Admin Panel</span>
          </Link>
        </div>
        <div>
          <button
            className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 text-white"
            id=""
            onClick={sidebarToggle}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <form className="d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
        {/* <div className="input-group">
          <input
            className="form-control SearchS "
            type="search"
            placeholder="Search for..."
            aria-label="Search for..."
            aria-describedby="btnNavbarSearch"
          />
          <button
            className="btn btn-warning btnS "
            id="btnNavbarSearch"
            type="button"
          >
            <i className="fas fa-search"></i>
          </button>
        </div> */}
      </form>

      <ul className="navbar-nav navParent ">
        <Dropdown>
          <Dropdown.Toggle variant="dark" id="dropdown-basic">
            <i className="fas fa-bell"></i>
            {scheduleNofication && scheduleNofication.length > 0 ? (
              <>
                <span className="text-danger badge badge-danger">
                  {scheduleNofication.length}
                </span>
              </>
            ) : (
              <></>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {scheduleNofication && scheduleNofication.length > 0 ? (
              <>
                {scheduleNofication &&
                  scheduleNofication.map((schedule) => (
                    <Dropdown.Item>
                      Schedule{" "}
                      {`Date: ${moment(schedule.date).format(
                        "LL"
                      )} | From : ${moment(schedule.from, "HH:mm:ss").format(
                        "hh:mm A"
                      )} | To:  ${moment(schedule.to, "HH:mm:ss").format(
                        "hh:mm A"
                      )}`}{" "}
                    </Dropdown.Item>
                  ))}
              </>
            ) : (
              <></>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </ul>

      <TopInfo
        profile={"/superstar-admin/profile"}
        settings={"/superstar-admin/profile-settings"}
      />
    </nav>
  );
};

export default AdminNavbar;
